import {AfterViewInit, Component, EventEmitter, forwardRef, Input, OnInit, Output, ViewChild} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {Deferred} from '../../core/global_function';
import {ActivatedRoute, Router} from '@angular/router';
import {Global_DB} from '../../core/global_db';

declare var $: any;

@Component({
    selector: 'manyimages',
    templateUrl: 'manyimages.component.html',
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => ManyimagesComponent),
        multi: true
    }]
})
export class ManyimagesComponent implements OnInit, ControlValueAccessor, AfterViewInit {
    // ControlValueAccessor props
    private propagateTouch = () => { };
    private propagateChange = (_: any) => { };



    _flag_upload: boolean = true;
    @Input()
    set flag_upload(vl: boolean) {
        this._flag_upload = vl;
    }
    get flag_upload() {
        return this._flag_upload;
    }
    _show_image: boolean = true;
    @Input()
    set show_image(vl) {
        this._show_image = vl;
    }
    get show_image() {
        return this._show_image;
    }
    @Input()
    data: any;

    @Input()
    set value(vl: any) {
        this._value = vl;
    }
    get value() {
        return this._value;
    }

    @Input()
    set link(vl: any) {
        this._link = vl;
        this.setListImage();
    }
    _link: string;

    @Input()
    set limit(vl: any) {
        this._limit = vl;
    }
    _limit: Number = 20;

    @Input()
    set link_api(vl: any) {
        this._link_api = vl;
    }
    _link_api: string;
    link_image: string;

    @Input()
    set attribute_api(vl: any) {
        this._attribute_api = vl;
    }
    _attribute_api: {};

    @ViewChild('input') _input: any;
    @ViewChild('upload') _upload: any;
    @ViewChild('button') _button: any;

    choice_image() {
        this._button.nativeElement.click();
    }

    @Input()
    cssImport: any;

    @Input()
    width: any;

    @Input()
    disabled: any;

    @Input()
    options: any;

    @Output()
    initLoad = new EventEmitter<any>();

    @Output()
    finishLoad = new EventEmitter<any>();

    @Output()
    valueChanged = new EventEmitter<any>();

    constructor(private route: ActivatedRoute, private router: Router, private db: Global_DB) { }

    ngOnInit() { }

    ngAfterViewInit() {
    }
    _value: any = '';
    writeValue(value: any): void {
        if (value === undefined || value === null) {
            this._value = '';
        } else {
            this._value = value;
        }
        this.setListImage();
    }


    list: any = [];
    setListImage() {
        if (this._value) {
            var rs = [];
            if (typeof (this._value) == 'string' && this._value != '') {
                rs = JSON.parse(this._value);
            } else {
                rs = this._value;
            }
            this.list = rs;
        } else {
            this.list = [];
        }

    }
    private sendModelChange(val: any) {
        this.propagateChange(this.getValueValue(val));
    }

    private getValueValue(val: any) {
        let result: any = val;
        if (!val) {
            return val;
        }
        return result;
    }

    registerOnChange(fn: any): void {
        this.propagateChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.propagateTouch = fn;
    }

    delete_image(item) {
        var rs = [];
        for (var i in this.list) {
            if (this.list[i].file_id != item.file_id) {
                rs.push(this.list[i]);
            }
        }
        this.list = rs;
        this._value = this.list;
        // this._value = this.list;
        this.sendModelChange(this._value);
        this.valueChanged.emit({
            type: 'change'
        });
    }

    click_broswer() {
        this._upload.nativeElement.click();
    }

    upload_one_file(file) {
        var that = this;
        var reader = new FileReader();
        var def = new Deferred();
        reader.onloadend = function () {
            var a = reader.result.split('base64,');
            var base64 = a[1];
            let url = "Content-Type:"+ file.type +"\r\nContent-Disposition:attachment;filename=\""+ file.name +"\"\r\nContent-Transfer-Encoding: base64\r\n\r\n" + base64;
                that.db.post(that._link_api, { url: url, name: file.name, size: file.size }).then(r => {
                    var item = {};
                    if (r && !r.error) {
                        r['url'] = r.url;
                        r['name']  = file.name;
                        r['size'] = file.size;
                        r['_value'] = r.file_id;
                        that.list.push(r);
                        that.sendModelChange(that.list);
                        that.valueChanged.emit({
                            type: 'change',
                            attributes: item
                        });
                        def.resolve(item);
                    } else {
                        def.resolve(r.error);
                    }
                })
        }
        reader.readAsDataURL(file);
        return def.promise;
    }
    obj_message: any;
    limit_size = 20 * 1024 * 1024;
    errorUpload;
    upload_image(event) {
        this.errorUpload = '';
        var that = this;
        var flag = true;
        var rs_message = [];
        var list_file_upload = [];
        var length = event.target.files.length;
        var count = length + this.list.length;
        if(count > this._limit) {
            this.obj_message.open({
                title: 'Upload file error',
                content: 'File size <= ' + this._limit,
                autoClose: true,
            });
            return false;
        }
        for (var i = 0; i < length; i++) {
            var file = event.target.files[i];
            var a = file.type.split('/');
            if (file.size < this.limit_size) {
                list_file_upload.push(file);
            } else {
                flag = false;
                rs_message.push('File is too large. Limit for the file \'' +file.name+'\' ' + (this.limit_size / (1024 * 1024)) + 'MB.');
            }
        }
        if (list_file_upload.length) {
            this.initLoad.emit(true);
            var COUNT_LIMIT = 0, LIMIT = list_file_upload.length;
            for (var i = 0; i < LIMIT; i++) {
                var file = list_file_upload[i];
                this.upload_one_file(file).then(r => {
                    COUNT_LIMIT++;
                    if (typeof (r) == 'string') {
                        rs_message.push(r);
                    }
                    event.target.value = '';
                    if (COUNT_LIMIT == LIMIT) {
                        this.finishLoad.emit(true);
                        if (rs_message.length) {
                            that.valueChanged.emit({
                                type: 'change_all'
                            });
                          this.errorUpload = rs_message.join("<br />");
                        }
                    }
                });
            }
        } else {
            event.target.value = '';
            this.errorUpload = rs_message.join("<br />");
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/common/component/manyimages/manyimages.component.ts